// @flow

export const INTEREST_LIST_FAVORITED = 'favorited';

export default undefined;
